export default __webpack_public_path__ + "static/media/tic-tac-toe.d896e6e7.png";